export default {
  user: {
    profile: '個人資訊',
    identification: '身份認證',
    bankCard: '銀行卡',
    deposit: '入金',
    withdraw: '出金',
  },
};
